<template>
  <div class="flex w-4">
    <div
      v-if="enabled"
      aria-label="flash"
      class="flex items-center justify-center h-4 aspect-square relative"
    >
      <span class="absolute inline-flex rounded-full h-3 aspect-square bg-orange" />
      <span class="absolute inline-flex rounded-full h-3 aspect-square bg-orange opacity-75 animate-ping" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  enabled: boolean
}>()
</script>
